var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-container"},[_vm._v("\n  "+_vm._s(_vm.suborder)+" "),_c('i',{staticClass:"el-icon-loading float-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }